import MultipleMatchPure from './MultipleMatchPure';

export default {
    data() {
        return {
            state: this.controller.state
        };
    },
    render: function (h) {
        return h(MultipleMatchPure, {
            props: {
                question: this.controller.getQuestion(),
                targetItems: this.controller.getTargetItems(),
                shelfItems: this.controller.getShelfItems(),
                match: this.controller.match.bind(this.controller),
                state: this.state
            },
            on: {
                done: () => {
                    this.$emit('done');
                }
            }
        });
    },
    props: {
        controller: {
            type: Object,
            required: true
        }
    }
};
